var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{key:_vm.key,attrs:{"value":1,"unchecked-value":0,"checked":_vm.checked,"disabled":_vm.disabled,"size":"lg"},on:{"change":_vm.setVote}})}
var staticRenderFns = []

export { render, staticRenderFns }